import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { tap } from 'rxjs/operators'
import { isAuthorized } from '../auth/auth.selectors'

@Injectable({ providedIn: 'root' })
export class AuthorizedUserGuard {
  constructor(private store: Store, private router: Router) {}
  canActivate() {
    return this.store.pipe(
      isAuthorized,
      tap((res) => res || this.router.navigateByUrl('/auth/login'))
    )
  }
}
